var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calendar_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.24 3.464v2.364M12.76 3.464v2.364"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.584 7.526v.5a.5.5 0 0 1-.5-.5h.5Zm10.832 0h.5a.5.5 0 0 1-.5.5v-.5Zm0-2.834v-.5a.5.5 0 0 1 .5.5h-.5Zm-10.832 0h-.5a.5.5 0 0 1 .5-.5v.5Zm0 2.834v-.5h10.832v1H4.584v-.5Zm10.832 0h-.5V4.692h1v2.834h-.5Zm0-2.834v.5H4.584v-1h10.832v.5Zm-10.832 0h.5v2.834h-1V4.692h.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.584 7.526v-.5a.5.5 0 0 0-.5.5h.5Zm10.832 0h.5a.5.5 0 0 0-.5-.5v.5Zm0 8.288v.5a.5.5 0 0 0 .5-.5h-.5Zm-10.832 0h-.5a.5.5 0 0 0 .5.5v-.5Zm0-8.288v.5h10.832v-1H4.584v.5Zm10.832 0h-.5v8.288h1V7.526h-.5Zm0 8.288v-.5H4.584v1h10.832v-.5Zm-10.832 0h.5V7.526h-1v8.288h.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calendar_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgCalendar;